/**
 * Hands a downloaded blob to the browser as a file — the repository profile's own steps. The
 * object URL is revoked at once: it is dead outside this tab anyway, and a live one is a handle
 * on evidence bytes nobody is using.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = window.document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;
  window.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
